// Router
import { Route, Routes, Navigate } from "react-router-dom";
// Project components
import SupportPage from "./pages/SupportPage/SupportPage";
import ContactUsPage from "./pages/ContactUsPage/ContactUsPage";
import UserAgreementPage from "./pages/PolicyPages/UserAgreementPage";
// import SignIn from "./pages/SignIn.tsx";

// Styles
import DashboardPage from "pages/DashboardPage";
import AddFirmPage from "pages/AddFirmPage/AddFirmPage";
import FirmsPage from "pages/FirmsPage/FirmsPage";

import AddProjectPage from "pages/AddProjectPage/AddProjectPage";
import ProjectsPage from "pages/ProjectsPage/ProjectsPage";
import AddProjectStructuralSystem from "pages/AddProjectPage/AddProjectStructuralSystem";
import AddProjectSubstructureQuantities from "pages/AddProjectPage/AddProjectSubstructureQuantities";
import AddProjectSuperstructureQuantities from "pages/AddProjectPage/AddProjectSuperstructureQuantities";
import AddProjectSuperstructureQuantitiesCont from "pages/AddProjectPage/AddProjectSuperstructureQuantitiesCont";
import AddProjectSmqAssumptions from "pages/AddProjectPage/AddProjectSmqAssumptions";
import AddProjectEmbodiedCarbonAssessment from "pages/AddProjectPage/AddProjectEmbodiedCarbonAssessment";
import AddProjectEmbodiedCarbonReporting from "pages/AddProjectPage/AddProjectEmbodiedCarbonReporting";


import EcomPage from "pages/EcomPage/EcomPage";
import AddEcomPage from "pages/AddEcomPage/AddEcomPage";
import AddEcomConcretePage from "pages/AddEcomPage/AddEcomConcretePage";
import AddEcomReinforcementPage from "pages/AddEcomPage/AddEcomReinforcementPage";
import AddEcomMasonryPage from "pages/AddEcomPage/AddEcomMasonryPage";
import AddEcomSteelPage from "pages/AddEcomPage/AddEcomSteelPage";
import AddEcomTimberPage from "pages/AddEcomPage/AddEcomTimberPage";

import UsersPage from "pages/UserPages/UsersPage";
import AddUserPage from "pages/AddUserPages/AddUserPage";
import AdminPage from "pages/UserPages/AdminPage";
import AddAdminPage from "pages/AddUserPages/AddAdminPage";
import LandingPage from "pages/LandingPage/LandingPage";
import SubSuperPage from "pages/UserPages/SubSuperPage";
import AddSubSuperPage from "pages/AddUserPages/AddSubSuperPage";
import ViewUserAgreementPage from "pages/ViewUserAgreementPage/ViewUserAgreementPage";
import CustomEmailPage from "pages/CustomEmailPage/CustomEmailPage";
import ViewPrivacyPolicyPage from "pages/ViewPrivacyPolicyPage/ViewPrivacyPolicy";
import PrivacyPolicyPage from "pages/PolicyPages/PrivacyPolicyPage";



const Navigation = () => {
  return (
    <Routes>
      {/* Home */}
      <Route path={"/landing"} element={<LandingPage />} />
      {/* Dashboard */}
      <Route path={"/dashboard"} element={<DashboardPage />} />
      {/* Firms */}
      <Route path={"/firms"} element={<FirmsPage />} />
      {/* Add New Firm */}
      <Route path={"/add-firm"} element={<AddFirmPage />} />
      {/* Sub Super Admin */}
      <Route path={"/sub-super-admin"} element={<SubSuperPage />} />
      {/* Add New Sub Super Admin */}
      <Route path={"/add-sub-super-admin"} element={<AddSubSuperPage />} />
      {/* Firm Admin */}
      <Route path={"/firm-admin"} element={<AdminPage />} />
      {/* Add New Admin */}
      <Route path={"/add-admin"} element={<AddAdminPage />} />
      {/* Firm Users */}
      <Route path={"/firm-users"} element={<UsersPage />} />
      {/* Add New User */}
      <Route path={"/add-user"} element={<AddUserPage />} />
      {/* Projects */}
      <Route path={"/projects"} element={<ProjectsPage />} />
      {/* Add Project Page */}
      <Route path={"/add-project/1"} element={<AddProjectPage />} />
      {/* Add Project Page 2 */}
      <Route path={"/add-project/2"} element={<AddProjectStructuralSystem />} />
      {/* Add Project Page 3 */}
      <Route path={"/add-project/3"} element={<AddProjectSubstructureQuantities />} />
      {/* Add Project Page 4 */}
      <Route path={"/add-project/4"} element={<AddProjectSuperstructureQuantities />} />
      {/* Add Project Page 5 */}
      <Route path={"/add-project/5"} element={<AddProjectSuperstructureQuantitiesCont />} />
      {/* Add Project Page 6 */}
      <Route path={"/add-project/6"} element={<AddProjectSmqAssumptions />} />
      {/* Add Project Page 7 */}
      <Route path={"/add-project/7"} element={<AddProjectEmbodiedCarbonAssessment />} />
      {/* Add Project Page 8 */}
      <Route path={"/add-project/8"} element={<AddProjectEmbodiedCarbonReporting />} />
      {/* ECOM */}
      <Route path={"/ecom"} element={<EcomPage />} />
      {/* Add ECOM Page */}
      <Route path={"/add-ecom/1"} element={<AddEcomPage />} />
      {/* Add ECOM Page 2 */}
      <Route path={"/add-ecom/2"} element={<AddEcomConcretePage />} />
      {/* Add ECOM Page 3 */}
      <Route path={"/add-ecom/3"} element={<AddEcomReinforcementPage />} />
      {/* Add ECOM Page 4 */}
      <Route path={"/add-ecom/4"} element={<AddEcomMasonryPage />} />
      {/* Add ECOM Page 5 */}
      <Route path={"/add-ecom/5"} element={<AddEcomSteelPage />} />
      {/* Add ECOM Page 6 */}
      <Route path={"/add-ecom/6"} element={<AddEcomTimberPage />} />
      {/* Contact Us */}
      <Route path={"/privacy-policy"} element={<PrivacyPolicyPage />} />
      {/* Terms of Service */}
      <Route path={"/user-agreement"} element={<UserAgreementPage />} />
      {/* Contact Us */}
      <Route path={"/contact-us"} element={<ContactUsPage />} />
      {/* Support */}
      <Route path={"/support"} element={<SupportPage />} />
      {/* View User Agreement */}
      <Route path={"/view-user-agreement"} element={<ViewUserAgreementPage />} />
      {/* View Privacy Policy */}
      <Route path={"/view-privacy-policy"} element={<ViewPrivacyPolicyPage />} />
      {/* Custom Email */}
      <Route path={"/custom-email"} element={<CustomEmailPage />} />
      {/* Redirect all 404's to home */}
      <Route path="*" element={<Navigate to={"/landing"} replace />} />
    </Routes>
  );
};

export default Navigation;
